{
  "Empty": "Tühjenda"
}
